import { render, staticRenderFns } from "./MedicalWasteManagement.vue?vue&type=template&id=08bab56a&scoped=true&"
import script from "./MedicalWasteManagement.vue?vue&type=script&lang=js&"
export * from "./MedicalWasteManagement.vue?vue&type=script&lang=js&"
import style0 from "./MedicalWasteManagement.vue?vue&type=style&index=0&id=08bab56a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bab56a",
  null
  
)

component.options.__file = "MedicalWasteManagement.vue"
export default component.exports